import type { HTMLProps } from "react";
import getClasses from "utils/getClasses";
import styles from "./styles.module.scss";

/**
 * !! different from boostrap toast
 * renders a static toast w/ a dark background
 */
const Toast = ({ className, ...props }: HTMLProps<HTMLDivElement>) => (
  <div className={getClasses(styles["toast"], className)} {...props} />
);
export default Toast;
